import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/home';
import AdminPage from './pages/admin';
import AdminMasterPage from './pages/admin_master';

const App:React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/:token' element={<HomePage />} />
        <Route path='/school' element={<AdminPage />} />
        <Route path='/master' element={<AdminMasterPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
